// @flow
import React from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import classnames from 'classnames';
import moment from 'moment';
import get from 'lodash/get';
import {types, terms, minAge, maxAge} from '../../utils/constants';
import 'moment/locale/es';
import './styles.css';

// Type definitions
import type {SelectOption, FormData} from '../../utils/types';

type Props = {
  className?: string,
  handleSubmit: (formData: FormData) => void
};

type State = {
  type: ?SelectOption,
  amount: string,
  duration: ?SelectOption,
  dob: ?moment
};

// Set locale for datepicker
moment.locale('es');

export default class Form extends React.Component<Props, State> {
  static defaultProps = {
    className: ''
  };

  state = {
    type: null,
    amount: '',
    duration: null,
    dob: null
  };

  handleTypeChange(type: SelectOption) {
    // Make sure to clear the duration field when switching loan types
    const duration = this.state.type !== type ? null : this.state.duration;

    this.setState({
      type,
      duration
    });
  }

  handleAmountChange(event: SyntheticEvent<HTMLInputElement>) {
    // @TODO: not sure how to type `event` in this case
    const amount: string = event.target.value;

    this.setState({
      amount
    });
  }

  handleDurationChange(duration: SelectOption) {
    this.setState({
      duration
    });
  }

  handleDOBChange(dob: moment) {
    this.setState({
      dob
    });
  }

  handleSubmit(event: SyntheticEvent<HTMLButtonElement>) {
    event.preventDefault();

    const formData: FormData = {
      type: this.state.type.value,
      amount: Number(this.state.amount),
      duration: this.state.duration.value
    };

    this.props.handleSubmit(formData);
  }

  render() {
    const {type, amount, duration, dob} = this.state;
    const formClassName = classnames('Form', this.props.className);

    // Prevent the user from submitting the form if:
    // - there's no loan type selected
    // - amount is not a valid value (including 0)
    // - there's no duration selected
    // - there's no DOB selected
    const isDisabled = !type || amount === '' || Number(amount) <= 0 || !duration || !dob;

    return (
      <form method="POST" className={formClassName}>
        <label className="Form__field">
          Tipo de préstamo:
          <Select
            placeholder="Seleccione una opción"
            className="Form__select"
            value={type}
            options={types}
            clearable={false}
            openOnFocus={true}
            onChange={this.handleTypeChange.bind(this)} />
        </label>

        <label className="Form__field">
          Monto a solicitar:
          <input
            placeholder="Ingrese un valor"
            className="Form__input"
            value={amount}
            type="number"
            onChange={this.handleAmountChange.bind(this)} />
        </label>

        <label className="Form__field">
          Plazo:
          <Select
            placeholder="Seleccione una opción"
            className="Form__select"
            value={duration}
            options={terms[get(this.state, 'type.value')] || []}
            clearable={false}
            openOnFocus={true}
            onChange={this.handleDurationChange.bind(this)} />
        </label>

        <label className="Form__field" htmlFor="datepicker">
          Fecha de nacimiento:
        </label>

        <DatePicker
          id="datepicker"
          placeholderText="Seleccione su fecha de nacimiento"
          className="Form__input"
          selected={dob}
          onChange={this.handleDOBChange.bind(this)}
          dateFormat="DD/MM/YYYY"
          dropdownMode="select"
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          readOnly // lower keyboard on mobile devices
          minDate={moment().subtract(maxAge, 'years')}
          maxDate={moment().subtract(minAge, 'years')} />

        <button className="Form__submit" disabled={isDisabled} onClick={this.handleSubmit.bind(this)}>
          Calcular
        </button>
      </form>
    );
  }
}
